/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_ChallengeInputs */

const en_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter Challenge`)
};

const ar_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحدي المبتدئين`)
};

const de_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter-Herausforderung`)
};

const es_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío inicial`)
};

const fr_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Défi découverte`)
};

const it_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sfida per principianti`)
};

const ja_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターターチャレンジ`)
};

const ko_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초보자 챌린지`)
};

const pt_br_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafio Inicial`)
};

const ru_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задача для новичков`)
};

const th_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความท้าทายเริ่มต้น`)
};

const tr_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç Mücadelesi`)
};

const zh_cn_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新手任务`)
};

const zh_tw_starter_challenge = /** @type {(inputs: Starter_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新手任務`)
};

/**
* | output |
* | --- |
* | "Starter Challenge" |
*
* @param {Starter_ChallengeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge = /** @type {((inputs?: Starter_ChallengeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_ChallengeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge(inputs)
	if (locale === "ar") return ar_starter_challenge(inputs)
	if (locale === "de") return de_starter_challenge(inputs)
	if (locale === "es") return es_starter_challenge(inputs)
	if (locale === "fr") return fr_starter_challenge(inputs)
	if (locale === "it") return it_starter_challenge(inputs)
	if (locale === "ja") return ja_starter_challenge(inputs)
	if (locale === "ko") return ko_starter_challenge(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge(inputs)
	if (locale === "ru") return ru_starter_challenge(inputs)
	if (locale === "th") return th_starter_challenge(inputs)
	if (locale === "tr") return tr_starter_challenge(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge(inputs)
	return zh_tw_starter_challenge(inputs)
});